import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import GoogleAnalytics from 'react-ga';

import Train from '../../services/train.js';
import User from '../../services/User.js';
import Facebook from '../../services/facebook.js';
import Element from '../../services/Element.js';
import Notification from '../../services/Notification.js';

class LoginForm extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      onClose: props.onClose,
      onFormChange: props.onFormChange
    }
  }

  successfulLogin(result) {
    this.state.onClose();
    User.startSession(result.token);
    let user = {user: User.getId(), name: User.getName()};
    this.props.history.push(Element.url('user', user));
    Notification.show(`Welcome, ${User.getName()}`, 'success');
  }

  failedLogin(error) {
    Notification.show(`Invalid login credentials`, 'error');
  }

  login(evt) {

    GoogleAnalytics.event({
      category: 'User',
      action: 'emailLogin'
    });

    evt.preventDefault();
    evt.stopPropagation();
    let email = this.refs.email.value;
    let password = this.refs.password.value;
    Train.authenticateUser({email, password})
    .then(this.successfulLogin.bind(this))
    .catch(this.failedLogin.bind(this));
  }

  twitterLogin(evt) {

    GoogleAnalytics.event({
      category: 'User',
      action: 'twitterLogin'
    });

    evt.preventDefault();
    evt.stopPropagation();
    Train.twitterLogin()
    .then((location) => {
      window.location = location;
    });
  }

  facebookLogin(evt) {

    GoogleAnalytics.event({
      category: 'User',
      action: 'facebookLogin'
    });


    evt.preventDefault();
    evt.stopPropagation();

    const scope = {scope: ['public_profile', 'email']};

    window.FB.login((response) => {
      if (response.status === 'connected')
      {
        Facebook.signup(response.authResponse)
        .then(this.successfulLogin.bind(this))
        .catch(this.failedLogin.bind(this));
      }
      }, scope
    );
  }

  validate() {
    this.setState({});
  }

  isInvalid() {

    return (
      !this.refs.email || !this.refs.password ||
      (this.refs.email && !this.refs.email.validity.valid) ||
      (this.refs.password && !this.refs.password.validity.valid)
    );
  }

  switchToSignupForm(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.state.onFormChange('register');
  }

  switchToRecoverform(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.state.onFormChange('recover');
  }

  render() {

    return (

      <form onSubmit={this.login.bind(this)} className="userForm" noValidate>
        <fieldset>
          <a className="closeButton" onClick={this.state.onClose}> 
            <i className="fontastic icon-close clickable"></i>
          </a>
          <h2 className="fs-title">Sign in</h2>
          <input type="email" ref="email" onChange={this.validate.bind(this)} autoFocus pattern="([\w\-\.\+]+@([\w\-]+\.)+[\w\-]{2,4})?" minLength="4" maxLength="80" required placeholder="E-mail" />
          <input type="password" ref="password" onChange={this.validate.bind(this)} minLength="8" maxLength="30" required placeholder="Password" />
          <input disabled={this.isInvalid()} type="submit" className="submit action-button clickable" value="Login" />
          <input type="button" onClick={this.twitterLogin.bind(this)} className="submit action-button clickable twitter" value="Twitter" />
          <input type="button" onClick={this.facebookLogin.bind(this)} className="submit action-button clickable facebook" value="Facebook" />
          <a onClick={this.switchToSignupForm.bind(this)} className="clickable switchLink">Not a user?</a><br/>
          <a onClick={this.switchToRecoverform.bind(this)} className="clickable switchLink">Recover password?</a><br/>
        </fieldset>

      </form>

    );
  }

}

export default withRouter(LoginForm);



// WEBPACK FOOTER //
// ./src/js/components/credentials/LoginForm.jsx